var map = {
	"./airbnb.svg": 865,
	"./algolia.svg": 866,
	"./appbase.svg": 867,
	"./buffer.svg": 868,
	"./coursera.svg": 869,
	"./dbsbank.svg": 870,
	"./lonelyplanet.svg": 871,
	"./mozilla.svg": 872,
	"./nulogy.png": 873,
	"./postmates.png": 874,
	"./quran.svg": 875,
	"./remitly.svg": 876,
	"./slack.svg": 877,
	"./squarespace.png": 878,
	"./wix.svg": 879
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;



//////////////////
// WEBPACK FOOTER
// ./src/pages/logos ^\.\/.*$
// module id = 882
// module chunks = 213534597649335